const contacts = {
  phone: '02 83987304',
  phoneHref: 'tel:+390283987304',
  address: 'Via Stra Meda 41, Ceriano Laghetto',
  mapsUrl:
    "https://www.google.it/maps/place/L'angolo+Verde/@45.6314185,9.0739684,17z/data=!3m1!4b1!4m5!3m4!1s0x478696964c366cad:0xa8e6853688bd173a!8m2!3d45.6314096!4d9.0761574",
  instagramUrl: 'https://www.instagram.com/angoloverdeceriano/',
  instagramHandle: '@angoloverdeceriano',
  hours: [
    { days: 'Lunedì – Giovedì', time: '6:30 – 18:30' },
    { days: 'Venerdì', time: '6:30 – 19:30' },
    { days: 'Sabato', time: '6:30 – 12:30' },
  ],
};

export default contacts;
